import classNames from "@casino/external/classNames";

const Container: FC<React.HTMLAttributes<HTMLDivElement>> = ({
  children,
  className,
  ...props
}) => (
  <div
    className={classNames(
      "grid place-items-center gap-10 w-screen h-screen p-8 bg-background text-foreground text-xl text-center",
      className,
    )}
    style={{ alignContent: "center", gridTemplateRows: "auto auto 2rem" }}
    {...props}
  >
    {children}
  </div>
);
export default Container;
